const IMAGE_SELECTOR = '.stamped-reviews-image img';
const LINK_SELECTOR = '.stamped-reviews-link';

const accessibleNameFromContext = (link) => {
    const root = link.closest('.stamped-reviews-single, .stamped-reviews-widget, .stamped-review');
    const title = root?.querySelector(
        '.stamped-reviews-title, .stamped-review-header-title, .stamped-review-title'
    );
    return title?.textContent.trim() || '';
};

const setAriaLabel = (el, fallback) => {
    if (el.hasAttribute('aria-label') || el.hasAttribute('aria-labelledby')) return;
    if (el.textContent.trim()) return;
    el.setAttribute('aria-label', accessibleNameFromContext(el) || fallback);
};

const labelize = () => {
    document.querySelectorAll(IMAGE_SELECTOR).forEach((img) => {
        if (img.hasAttribute('alt')) return;
        img.setAttribute('alt', '');

        const wrappingLink = img.closest('a');
        if (wrappingLink) setAriaLabel(wrappingLink, 'View review');
    });

    document.querySelectorAll(LINK_SELECTOR).forEach((link) => setAriaLabel(link, 'View review'));
};

const schedule = () => {
    labelize();
    setTimeout(labelize, 1500);
    setTimeout(labelize, 5000);
};

export default function labelizeStampedImages() {
    if (document.readyState === 'complete') {
        schedule();
        return;
    }
    window.addEventListener('load', schedule, { once: true });
}
